export class Header {
  image: string = '';
  video: string = '';
  type: 'image' | 'video' | 'special-effect' = 'image'; 
}


// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/products/shared/models/header.model.ts